import { render, staticRenderFns } from "./Side-Trouble-Custom-Group.vue?vue&type=template&id=63bb6a74&"
import script from "./Side-Trouble-Custom-Group.vue?vue&type=script&lang=js&"
export * from "./Side-Trouble-Custom-Group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports